import { AuthorizationState } from 'store/models/authModels'
import { useAppSelector } from 'store/useStoreHook'

function useAuth() {
    const isAuthenticated = useAppSelector(
        (state) =>
            state.auth.authState === AuthorizationState.SUCCESS_REAL_CLIENT,
    )
    const isAuthorizing = useAppSelector(
        (state) =>
            state.auth.authState === AuthorizationState.PREPARE ||
            state.auth.authState === AuthorizationState.PROCESSING,
    )

    return {
        isAuthenticated,
        isAuthorizing,
    }
}

export default useAuth
